/* TPW PRODUCT CARD v3 — hover-crossfade + quick-add engine (MVP, 2026-06-20).
   The in-card multi-image SCROLL gallery (arrows / counter / swipe / wheel
   axis-routing) was removed for MVP — backed up in
   _card-gallery-scroll-backup/. The card now shows the main image and
   cross-fades to a SECOND image on hover (desktop pointer only). One delegated
   engine for every card surface, including cards that arrive later via AJAX
   (predictive search, recommendations, load-more):
   - the hover image is DEFERRED (loads on first hover/focus, never on touch)
   - clicks: capture-phase delegation on document (never triggers the card link)
   - add to cart: /cart/add.js + cart-icon-bubble section re-render */
(function () {
  "use strict";
  if (window.__tpwCardV3) return;
  window.__tpwCardV3 = true;

  /* ---- image reveal + transition arming ----------------------------------
     1) Reveal each card image with an opacity fade (CSS .is-imgloaded),
        robust to already-cached/complete images + load event + a failsafe.
     2) ARM the fade transitions only AFTER first paint is done, by adding
        <html>.tpwc-armed, so nothing animates on initial load. */
  function revealImg(img) {
    if (!img || img.__tpwcRevealed) return;
    /* NEVER reveal an un-hydrated DEFERRED (hover) image: its src is still the
       transparent 1×1 placeholder, so .is-imgloaded would paint a grey box.
       The deferred hover image is revealed by hydrate() once it has a real src. */
    if (img.hasAttribute("data-tpwc-src")) return;
    img.__tpwcRevealed = true;
    img.classList.add("is-imgloaded");
  }
  function wireImg(img) {
    if (img.__tpwcWired) return;
    /* the deferred hover image carries only a 1×1 placeholder until first hover;
       don't reveal/wire it now (it's already "complete") — hydrate() handles it. */
    if (img.hasAttribute("data-tpwc-src")) return;
    img.__tpwcWired = true;
    if (img.complete && img.naturalWidth > 0) { revealImg(img); return; }
    img.addEventListener("load", function () { revealImg(img); }, { once: true });
    img.addEventListener("error", function () { revealImg(img); }, { once: true });
  }
  function scanImgs(root) {
    (root || document).querySelectorAll("img.tpwc__img").forEach(wireImg);
  }

  /* ---- deferred hover-image hydration ------------------------------------
     On the FIRST interaction with a card (pointerenter / focusin / touchstart),
     copy data-tpwc-src -> src so the SECOND image begins loading, then fade it
     in on load. Guarded once per host. Touch devices never hover, so the image
     simply never loads there — pure perf win. */
  function hydrate(host) {
    if (!host || host.__tpwcHydrated) return;
    host.__tpwcHydrated = true;
    host.querySelectorAll("img[data-tpwc-src]").forEach(function (img) {
      var srcset = img.getAttribute("data-tpwc-srcset");
      var sizes = img.getAttribute("data-tpwc-sizes");
      img.__tpwcWired = true;
      img.__tpwcRevealed = false;
      img.classList.remove("is-imgloaded");
      img.addEventListener("load", function () { revealImg(img); }, { once: true });
      img.addEventListener("error", function () { revealImg(img); }, { once: true });
      if (sizes) img.setAttribute("sizes", sizes);
      if (srcset) img.setAttribute("srcset", srcset);
      /* deferred <img> ships loading="lazy"; once we hand it a real src, force
         eager so the fetch actually happens for the just-hovered card. */
      img.setAttribute("loading", "eager");
      img.setAttribute("src", img.getAttribute("data-tpwc-src"));
      img.removeAttribute("data-tpwc-src");
      img.removeAttribute("data-tpwc-srcset");
      img.removeAttribute("data-tpwc-sizes");
      if (img.complete && img.naturalWidth > 0) revealImg(img);
    });
  }
  function hydrateFrom(target) {
    if (!target || !target.closest) return;
    var host = target.closest(".tpwc-host");
    if (host) hydrate(host);
  }

  function armCards() {
    var html = document.documentElement;
    scanImgs(document);
    /* arm the fade transitions on the next frame so the first paint is static.
       rAF can be throttled to never-fire in background tabs (documented QA
       lesson), so a setTimeout failsafe guarantees the armed state lands. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { html.classList.add("tpwc-armed"); });
    });
    setTimeout(function () { html.classList.add("tpwc-armed"); }, 200);
    /* failsafe: never leave a MAIN image stuck invisible (deferred hover images
       are skipped by revealImg until hydrated). */
    setTimeout(function () {
      document.querySelectorAll("img.tpwc__img:not(.is-imgloaded)").forEach(revealImg);
    }, 2500);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", armCards, { once: true });
  } else {
    armCards();
  }

  /* cards arriving later (AJAX search / recs / load-more): wire their imgs.
     The page is already armed, so they fade in cleanly as they load. */
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches("img.tpwc__img")) wireImg(n);
        else if (n.querySelectorAll) scanImgs(n);
      }
    }
  });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  else document.addEventListener("DOMContentLoaded", function () {
    mo.observe(document.body, { childList: true, subtree: true });
  }, { once: true });

  /* Section ids we need refreshed after a card add: the header bubble (count +
     total, which then ROLL via tpw-cart-roll.js) AND the drawer contents, so the
     drawer is CURRENT the instant a shopper opens it (founder bug 2026-06-26 —
     card adds previously left the drawer stale until a slow interceptor caught
     up). We request these in the SAME /cart/add.js call (one round-trip). */
  var CARD_SECTION_IDS = "cart-icon-bubble,cart-drawer";

  /* Swap the header bubble + drawer inner from a sections payload (from the add
     response, or a standalone ?sections= fetch as fallback). */
  function applyCartSections(sections) {
    if (!sections) return;
    if (sections["cart-icon-bubble"]) {
      var bHolder = document.createElement("div");
      bHolder.innerHTML = sections["cart-icon-bubble"];
      var freshBubble = bHolder.querySelector("#cart-icon-bubble") ||
        bHolder.querySelector(".shopify-section") || bHolder.firstElementChild;
      document.querySelectorAll("#cart-icon-bubble").forEach(function (el) {
        if (freshBubble) el.innerHTML = freshBubble.innerHTML;
      });
    }
    if (sections["cart-drawer"]) {
      var dHolder = document.createElement("div");
      dHolder.innerHTML = sections["cart-drawer"];
      var freshDrawer = dHolder.querySelector("#CartDrawer");
      var cartDrawer = document.querySelector("cart-drawer");
      var liveDrawer = cartDrawer && cartDrawer.querySelector("#CartDrawer");
      if (freshDrawer && liveDrawer) {
        liveDrawer.innerHTML = freshDrawer.innerHTML;
        cartDrawer.classList.remove("is-empty");
        var inner = cartDrawer.querySelector(".cart-drawer__inner");
        var cdi = cartDrawer.querySelector("cart-drawer-items");
        if (inner) inner.classList.remove("is-empty");
        if (cdi) cdi.classList.remove("is-empty");
        var overlay = cartDrawer.querySelector("#CartDrawer-Overlay");
        if (overlay) overlay.addEventListener("click", function () { cartDrawer.close(); });
      }
    }
  }

  /* Fallback: standalone section fetch (used only if the add response carried no
     sections, e.g. an older add path). */
  function refreshCartBubble() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    fetch(root + "?sections=" + CARD_SECTION_IDS, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(applyCartSections)
      .catch(function () {});
  }

  /* crisp straight-stroke tick (square caps + miter) — not a curvy glyph */
  var CHECK_SVG = '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true"><path d="M3.5 8.4L6.7 11.4L12.5 4.8" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="square" stroke-linejoin="miter"/></svg>';

  /* product type -> personal "[thing] is yours!" success line. Read off the
     card root's data-tpw-type; safe default inside ownLine(). */
  function cardType(el) {
    var card = el && el.closest ? el.closest("[data-tpw-type]") : null;
    return card ? (card.getAttribute("data-tpw-type") || "") : "";
  }
  function ownLine(el) {
    return (window.TPWLoading && TPWLoading.ownLine)
      ? TPWLoading.ownLine(cardType(el)) : "It's yours!";
  }

  function add(btn) {
    if (btn.__busy) return;
    var vid = btn.getAttribute("data-tpwc-vid");
    if (!vid) return;
    btn.__busy = true;
    /* the glass + button swaps its icon to a tick; the hover bar swaps text.
       P1 "the Beam": both now run the shared working->done language via
       window.TPWLoading — the round + sweeps an ARC beam (shape:circle), the
       wide hover bar fills a hairline (shape:wide). Both contrast their dark
       surface with a WHITE beam. Guarded: fall back to the old instant tick. */
    var isPlus = btn.classList.contains("tpwc__plus");
    var savedHTML = btn.innerHTML;
    var label = btn.textContent;
    var TL = window.TPWLoading;

    if (TL) {
      if (isPlus) {
        // arc-beam working state: hide the static + glyph while the ring sweeps.
        // The glass surface is LIGHT, so the working ring is an INK beam; on done
        // the button flips to its ink .is-added bg with a WHITE centre tick.
        btn.dataset.tpwcIcon = savedHTML;
        btn.innerHTML = "";
        TL.start(btn, { shape: "circle", onColor: "light" });
      } else {
        TL.start(btn, { shape: "wide", onColor: "dark", label: "Adding" });
      }
    } else {
      // legacy fallback: no in-flight (jumps straight to done on resolve)
    }

    // claim this add so the global cart refresher skips its redundant fetch
    window.__tpwCartHandled = Date.now();
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1, sections: CARD_SECTION_IDS, sections_url: location.pathname }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("add failed");
        return r.json();
      })
      .then(function (res) {
        window.__tpwCartHandled = Date.now();
        // /cart/add.js sections are unreliable on this theme — always pull from
        // the dedicated ?sections= endpoint so the header count + drawer never go
        // stale (matches the pdpv9 guaranteed-refresh fix, founder 2026-06-26).
        refreshCartBubble();
        if (TL) {
          if (isPlus) {
            // the round + : flip to the ink .is-added bg + draw a WHITE centre tick
            btn.classList.add("is-added");
            btn.style.setProperty("--tpwl-beam", "#FFFFFF");
            TL.done(btn, { hold: 1600, idleLabel: "" });
            setTimeout(function () {
              btn.classList.remove("is-added");
              btn.style.removeProperty("--tpwl-beam");
              btn.innerHTML = btn.dataset.tpwcIcon || savedHTML;
              delete btn.dataset.tpwcIcon;
              btn.__busy = false;
            }, 1600);
          } else {
            TL.done(btn, { tick: false, label: ownLine(btn), hold: 1600, idleLabel: label });
            setTimeout(function () { btn.__busy = false; }, 1600);
          }
        } else {
          btn.classList.add("is-added");
          if (isPlus) { btn.innerHTML = CHECK_SVG; } else { btn.textContent = ownLine(btn); }
          setTimeout(function () {
            btn.classList.remove("is-added");
            if (isPlus) { btn.innerHTML = savedHTML; } else { btn.textContent = label; }
            btn.__busy = false;
          }, 1600);
        }
      })
      .catch(function () {
        if (TL) {
          TL.reset(btn);
          if (isPlus) { btn.innerHTML = btn.dataset.tpwcIcon || savedHTML; delete btn.dataset.tpwcIcon; }
          else { btn.textContent = label; }
        } else {
          if (isPlus) { btn.innerHTML = savedHTML; } else { btn.textContent = label; }
        }
        btn.__busy = false;
      });
  }

  document.addEventListener(
    "click",
    function (e) {
      if (!e.target.closest) return;
      var addBtn = e.target.closest("[data-tpwc-add]");
      if (addBtn) { e.preventDefault(); e.stopPropagation(); add(addBtn); return; }
      var choose = e.target.closest("[data-tpwc-choose]");
      if (choose) {
        e.preventDefault(); e.stopPropagation();
        var media = choose.closest(".tpwc__media");
        var panel = media && media.querySelector("[data-tpwc-opts]");
        if (panel) panel.classList.add("is-open");
        return;
      }
      var closeBtn = e.target.closest("[data-tpwc-optclose]");
      if (closeBtn) {
        e.preventDefault(); e.stopPropagation();
        closeBtn.closest("[data-tpwc-opts]").classList.remove("is-open");
        return;
      }
      var opt = e.target.closest("[data-tpwc-optadd]");
      if (opt) {
        e.preventDefault(); e.stopPropagation();
        if (opt.disabled || opt.__busy) return;
        opt.__busy = true;
        var nm = opt.querySelector(".tpwc__opt-nm");
        var label = nm ? nm.textContent : "";
        var TLo = window.TPWLoading;
        // P1 beam on the ledger row: ink beam working on the white row; on done
        // the row flips to its ink .is-added bg (text -> white via CSS).
        if (TLo) { TLo.start(opt, { shape: "wide", onColor: "light", labelEl: nm, label: "Adding" }); }
        window.__tpwCartHandled = Date.now();
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: parseInt(opt.getAttribute("data-tpwc-vid"), 10), quantity: 1, sections: CARD_SECTION_IDS, sections_url: location.pathname }),
        })
          .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
          .then(function (res) {
            window.__tpwCartHandled = Date.now();
            refreshCartBubble(); // always reliable refresh (add-response sections unreliable)
            opt.classList.add("is-added");
            if (TLo) {
              // white tick on the ink bg
              opt.style.setProperty("--tpwl-beam", "#FFFFFF");
              TLo.done(opt, { tick: false, label: ownLine(opt), labelEl: nm, hold: 900, idleLabel: label });
              setTimeout(function () {
                opt.classList.remove("is-added");
                opt.style.removeProperty("--tpwl-beam");
                opt.__busy = false;
                var panel = opt.closest("[data-tpwc-opts]");
                if (panel) panel.classList.remove("is-open");
              }, 900);
            } else {
              if (nm) nm.textContent = ownLine(opt);
              setTimeout(function () {
                opt.classList.remove("is-added");
                if (nm) nm.textContent = label;
                opt.__busy = false;
                var panel = opt.closest("[data-tpwc-opts]");
                if (panel) panel.classList.remove("is-open");
              }, 900);
            }
          })
          .catch(function () {
            if (TLo) { TLo.reset(opt, label); opt.classList.remove("is-added"); opt.style.removeProperty("--tpwl-beam"); }
            opt.__busy = false;
          });
        return;
      }
      /* clicks anywhere else inside an OPEN options panel must not follow the card link */
      var insidePanel = e.target.closest("[data-tpwc-opts]");
      if (insidePanel) { e.preventDefault(); e.stopPropagation(); }
    },
    true
  );

  /* FIRST-INTERACTION hydration: the moment a user hovers / focuses into / taps
     a card, load its deferred SECOND image so the hover cross-fade has a real
     image to show. Capture-phase, passive, document-level — AJAX-card-safe. */
  /* ---- cursor-scrub (desktop only) -----------------------------------------
     Moving the cursor across a card's image steps through that product's extra
     images (2..N), chosen by horizontal cursor position. Silent — no indicators.
     Attached lazily on first hover; gated to fine-pointer devices so touch never
     loads or shows the frames. */
  var SCRUB_OK = null;
  function scrubOk() {
    if (SCRUB_OK === null) SCRUB_OK = !!(window.matchMedia && window.matchMedia("(hover:hover) and (pointer:fine)").matches);
    return SCRUB_OK;
  }
  function setupScrub(media) {
    if (!media || media.__tpwScrub || !scrubOk()) return;
    var frames = media.querySelectorAll(".tpwc__img--frame");
    if (!frames.length) return;
    media.__tpwScrub = true;
    var segs = media.querySelectorAll(".tpwc__seg");
    var N = frames.length + 1, rect = null, cur = -1;
    function measure() { rect = media.getBoundingClientRect(); }
    function setZone(i) {
      if (i === cur) return;
      cur = i;
      var oi = i - 1; /* -1 = main image (no overlay) */
      for (var k = 0; k < frames.length; k++) frames[k].classList.toggle("is-on", k === oi);
      for (var s = 0; s < segs.length; s++) segs[s].classList.toggle("is-active", s === i);
    }
    media.addEventListener("mouseenter", measure);
    media.addEventListener("mousemove", function (e) {
      if (!rect) measure();
      var i = Math.floor(((e.clientX - rect.left) / rect.width) * N);
      if (i < 0) i = 0; else if (i > N - 1) i = N - 1;
      setZone(i);
    });
    media.addEventListener("mouseleave", function () { setZone(0); });
  }
  function onIntent(e) {
    if (!scrubOk()) return; /* touch: never hydrate/scrub the deferred frames */
    hydrateFrom(e.target);
    if (e.target.closest) {
      var m = e.target.closest(".tpwc__media");
      if (m) setupScrub(m);
    }
  }
  document.addEventListener("pointerenter", onIntent, { capture: true, passive: true });
  document.addEventListener("pointerdown", onIntent, { capture: true, passive: true });
  document.addEventListener("focusin", onIntent, { capture: true });
  document.addEventListener("touchstart", onIntent, { capture: true, passive: true });
  /* pointerenter does not bubble; mouseover (which bubbles) is the safety net. */
  document.addEventListener("mouseover", onIntent, { capture: true, passive: true });
})();
